import { useEffect, useState } from 'react'
import { apiURL } from '../../../../../utilities/URLs'
import { account } from '../../../../../classes/Account'
import { refreshAccessToken } from '../../../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export default function DashboardFAQTile() {
  const navigate = useNavigate()

  const [faqs, setFAQs] = useState([])
  const [openIndex, setOpenIndex] = useState(null)

  const toggleFAQ = (index) => { setOpenIndex(openIndex === index ? null : index) }

  useEffect(() => {
    const handleGetFAQs = async () => {
      const faqsResponse = await fetch(`${apiURL}/api/faqs/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const faqsData = await faqsResponse.json()
      if (faqsData.response.error) {
        if (faqsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetFAQs() : navigate('/', { state: { expired: true } })
        } else
          console.error(faqsData.response.error)
      } else
        setFAQs(faqsData.response.faqs)
    }

    handleGetFAQs()
  }, [navigate])

  return (
    <div className='w-full sm:w-1/3 max-h-80 p-6 rounded-2xl bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 shadow-sm flex flex-col gap-4 text-slate-800 dark:text-gray-100 transition-colors duration-300'>
      <p className='text-start w-full text-xl font-bold'>Frequently Asked Questions</p>
      <div className='w-full flex flex-col gap-3 overflow-y-auto pr-2 custom-scrollbar'>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className='border-b border-gray-100 dark:border-slate-700 pb-3 cursor-pointer group'
            onClick={() => toggleFAQ(index)}
          >
            <div className='flex flex-col'>
              <p className='font-bold text-sm text-slate-800 dark:text-gray-100 group-hover:text-ertc-primary transition-colors'>{faq.question}</p>
              <p className='mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed'>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
